/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
// Component
import SectionUI from '@components/UI/Common/SectionUI';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import UpcomingProgram from '@landing_pages/project-samskriti/UpcomingProgram';

/* Services */
/* Styles */

/**
 * Renders Expression Component
 * @param {Object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 */
const PsUpcomingProgram = ({ sectionContent, lang, region, id }) => {
  return (
    <Box w="full">
      <Box
        id={id}
        width={'100%'}
        height="auto"
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        background="#F6F6F6"
        pb="50px"
        // px={{
        //   xl: 'calc((100% - 1112px) / 2)',
        //   lg: '18px',
        //   md: '18px',
        //   sm: '18px',
        //   base: '18px',
        // }}
      >
        {sectionContent && sectionContent.length
          ? sectionContent.map(section => {
              if (
                section._modelApiKey === 'samskriti_upcoming_program_detail'
              ) {
                return (
                  <UpcomingProgram
                    key={nanoid(5)}
                    sectionContent={section}
                    region={region}
                    lang={lang}
                  />
                );
              } else if (section._modelApiKey === 'structured_text') {
                return (
                  <Box
                    // display="flex"
                    // alignItems="center"
                    // justifyContent="center"
                    margin="auto"
                    textAlign="center"
                    fontStyle="italic"
                    color="#7E7E7E"
                    key={nanoid(5)}
                  >
                    <StructuredTextParser
                      str={render(section.body)}
                      region={region}
                      lang={lang}
                      textAlign={section.style}
                    />
                  </Box>
                );
              } else {
                return (
                  <SectionUI
                    key={nanoid(4)}
                    sectionContent={section}
                    region={region}
                    language={lang}
                  />
                );
              }
            })
          : null}
      </Box>
    </Box>
  );
};

export default PsUpcomingProgram;
